// Value display mode for the pivot. The Builder shows one OR the other, never
// both: raw Count, or Percentage of the grand total.
//
// Percent uses the grand total as its single base, so cells, row/column totals
// and the grand total (which reads as 100%) are all comparable on one scale.

export const VALUE_COUNT = "count";
export const VALUE_PERCENT = "percent";
export const VALUE_MODES = [VALUE_COUNT, VALUE_PERCENT];

/**
 * Formats a pivot value for display.
 * @param {number} value
 * @param {number} total - grand total; the percentage base
 * @param {string} [mode] - VALUE_COUNT | VALUE_PERCENT
 * @returns {string|number} the raw count in count mode, a "12.5%" string in percent mode
 */
export const formatValue = (value, total, mode = VALUE_COUNT) => {
  if (mode !== VALUE_PERCENT) return value;
  return `${percentOf(value, total)}%`;
};

/**
 * Numeric percentage of `value` over `total`, rounded to one decimal (trailing
 * ".0" dropped). Zero when there is no total. Used for charts, which need a
 * plain number rather than a formatted string.
 * @returns {number}
 */
export const percentOf = (value, total) => {
  if (!total) return 0;
  return Number(((value / total) * 100).toFixed(1));
};
